import type { BookingsGuestDetails } from '@yescapa-dev/ysc-api-js/legacy'
import { BOOKING_STATES } from '@yescapa-dev/ysc-api-js/modern'

export const useCanPayBookingGuest = ({ state }: Partial<Pick<BookingsGuestDetails, 'state'>>) => {
  return state === BOOKING_STATES.ACCEPTED || state === BOOKING_STATES.TO_COME_NOT_PAID
}
